/**
 * Watchlist relationship layer (SEEKER_HUB_PLAN.md Phase 5 item 2): a single enum, no kanban —
 * networking status for a followed company, doubling as a Watchlist filter.
 */
export type RelationshipTag = 'interested' | 'reached_out' | 'in_conversation';

export const RELATIONSHIP_TAG_ORDER: RelationshipTag[] = ['interested', 'reached_out', 'in_conversation'];

export function isRelationshipTag(value: unknown): value is RelationshipTag {
  return value === 'interested' || value === 'reached_out' || value === 'in_conversation';
}
